import React from 'react';
import { DisabledAdsWarningContainer } from 'components/AdInsertion/styles';
import { useT } from 'client/i18n/hooks/useT';

export const ENABLE_PAYWALLS_DISABLED_ADS_WARNING = true;

export function AdInsertionPaywallDisabledAdsWarning({
  isPWEpisode,
  hasAdCuePoints,
  hasAdSegments,
}: {
  isPWEpisode?: boolean;
  hasAdCuePoints: boolean;
  hasAdSegments: boolean;
}) {
  const t = useT();
  const hasAds = hasAdCuePoints || hasAdSegments;
  if (!isPWEpisode || !hasAds) return null;
  return (
    <DisabledAdsWarningContainer>
      <p>
        {t(
          'AdInsertion.AdInsertionPaywallDisabledAdsWarning.Message',
          'Ads by Anchor features will be disabled for subscription episodes.',
          'Ads disabled in subscription episodes warning modal message'
        )}
      </p>
    </DisabledAdsWarningContainer>
  );
}
